import BlueSkyRulesPage from './BlueSkyRulesPage'

export default BlueSkyRulesPage
